export const USER = '/user'
export const USER_SETTINGS = `${USER}/settings/` as const
export const USER_INFO = `${USER}/me/info` as const
export const USER_ACTION_LOG = `${USER}/action/log` as const
export const USER_UPDATE_OWN_PASSWORD = `${USER}/own/password` as const
export const SIGN_IN = '/signin' as const
export const RESET_PASSWORD_REQUEST = '/action_verification_email/reset/password/request' as const
export const RESET_PASSWORD = '/action_verification_email/reset/password' as const
export const SIGN_UP = `/signup` as const
export const SMS_SEND = `/sms/send` as const
export const EMAIL_SEND = `/email/send` as const
export const VERIFY_EMAIl = `/verify-email` as const

// CONFERENCE
export const CONFERENCE = '/conference'
export const USER_CONFERENCE_INFO = `${USER}${CONFERENCE}/me/info` as const
export const CONFERENCE_SIGN_IN = `${CONFERENCE}${SIGN_IN}` as const
export const CONFERENCE_SIGN_UP = `${CONFERENCE}${SIGN_UP}` as const
export const CONFERENCE_AUTHOR_PROFILE = `${CONFERENCE}/author/profile` as const

// IConference
export const ICONFERENCE = '/iconference'
export const ICONFERENCE_SIGN_IN = `${ICONFERENCE}${SIGN_IN}` as const
export const ICONFERENCE_SIGN_UP = `${ICONFERENCE}${SIGN_UP}` as const
